import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Box, makeStyles, LinearProgress, Typography } from '@material-ui/core';
import { ListIndicator, NumberIndicator } from 'src/scenes/Project/components';


const useStyles = makeStyles(theme => ({
  auditableUnitLabel: {
    backgroundColor: '#F7931E !important',
  },
  itemRootBorder: {
    borderRight: `1px solid ${theme.palette.common.gray}`,
  },
}));

const ProjectMetrics = ({ indicators, rcas, isLoading }) => {
  const classes = useStyles();
  return (
    <Box mt={1}>
      {isLoading &&
        <Grid item xs={12}>
          <Box px={5} pt={3} pb={1} width="100%" display="flex" flexDirection="column">
            <LinearProgress />
            <Typography variant="overline" align="center">Cargando métricas del proyecto</Typography>
          </Box>
        </Grid>
      }
      <Grid container spacing={2}>
        {(rcas.length > 0 || indicators?.campaignsCount || indicators?.replicaStationsCount) && (
          <>
            <Grid item xs={4}>
              <Box height="88px" className={classes.itemRootBorder}>
                <ListIndicator
                  title="RCA's"
                  list={rcas}
                  color="primary"
                  isLoading={isLoading}
                  maxItems={5}
                />
              </Box>
            </Grid>
            <Grid item xs={4}>
              <Box className={classes.itemRootBorder} height="100%">
                <NumberIndicator
                  title="Campañas"
                  value={indicators.campaignsCount}
                  isLoading={isLoading}
                />
              </Box>
            </Grid>
            <Grid item xs={4}>
              <Box height="100%">
                <NumberIndicator
                  title="Estaciones replica"
                  value={indicators.replicaStationsCount}
                  isLoading={isLoading}
                />
              </Box>
            </Grid>
          </>
        )}
      </Grid>
    </Box>
  );
};

ProjectMetrics.propTypes = {
  indicators: PropTypes.object.isRequired,
  rcas: PropTypes.arrayOf(PropTypes.string).isRequired,
  isLoading: PropTypes.bool.isRequired,
};


export {
  ProjectMetrics,
};
